import { unsubscribeEmailApi } from "@serophin/nottldr-shared";
import { serophinContactUrl } from "@serophin/shared";
import { useEffect, useState } from "preact/hooks";
import type { PageProps } from "../pageProps";

type Status = { state: "working" } | { state: "done"; kind: string } | { state: "failed" };

const KIND_NAMES: Record<string, string> = { feedUpdate: "feed update", recommendedArticles: "recommended articles" };

const TITLE = "text-2xl font-semibold mb-4 text-neutral-900 dark:text-neutral-100";
const TEXT = "text-neutral-500 dark:text-neutral-400 mb-3";
const LINK = "underline hover:text-neutral-600 dark:hover:text-neutral-300";

const Message = ({ status }: { status: Status }) => {
  if (status.state === "working") {
    return <h1 class={TITLE}>Unsubscribing...</h1>;
  }
  if (status.state === "failed") {
    return (
      <>
        <h1 class={TITLE}>This link did not work</h1>
        <p class={TEXT}>
          Turn emails off in your{" "}
          <a href="/profile/settings?tab=email" class={LINK}>
            email preferences
          </a>{" "}
          instead, or{" "}
          <a href={serophinContactUrl("nottldr")} class={LINK}>
            contact us
          </a>{" "}
          and we will do it for you.
        </p>
      </>
    );
  }
  return (
    <>
      <h1 class={TITLE}>You are unsubscribed</h1>
      <p class={TEXT}>You will not get {KIND_NAMES[status.kind] ?? "these"} emails from !tldr any more.</p>
      <p class="text-sm text-neutral-400 dark:text-neutral-500">
        You can turn them back on in your{" "}
        <a href="/profile/settings?tab=email" class={LINK}>
          email preferences
        </a>
        .
      </p>
    </>
  );
};

export const EmailUnsubscribePage = (_props: PageProps) => {
  const [status, setStatus] = useState<Status>({ state: "working" });

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token") ?? "";
    unsubscribeEmailApi
      .invoke({ token }, { skipAuth: true })
      .then(({ kind }) => setStatus({ state: "done", kind }))
      .catch(() => setStatus({ state: "failed" }));
  }, []);

  return (
    <div class="flex justify-center items-center min-h-[60vh]">
      <div class="text-center p-10 max-w-md">
        <Message status={status} />
      </div>
    </div>
  );
};
